module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-RegularIt-866cb704.ttf";